module.exports = __webpack_public_path__ + "static/media/logo.458e9acb.png";